
import {throwError as observableThrowError, Observable} from 'rxjs';

import {tap} from 'rxjs/operators';
import {Injectable, Injector} from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler, HttpRequest,
    HttpErrorResponse
} from '@angular/common/http';
import {AuthenticationService} from "./authentication.service";
import {Router} from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private whitelistUrls = [
        '/api/v1/auth/login',
        '/api/v1/user',
        '/api/v1/auth/logout'
    ];

    constructor(private router: Router, private inj: Injector) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const authService = this.inj.get(AuthenticationService);
        const user = authService.user;

        if (user && user['accessToken'] && !req.headers.has('Authorization')) {
            req = req.clone({
                headers: req.headers
                    .set('Authorization', 'Bearer ' + user['accessToken'])
            });
        }

        if (user && user['accessToken']) {
            // Pass on the cloned request instead of the original request.
            return next.handle(req).pipe(
                tap(res => {}, res => {
                    // skip if whitelisted endpoint
                    if (this.isWhitelisted(req)) {
                        return;
                    }

                    if (res instanceof HttpErrorResponse && res.status === 401) {
                        authService.logout();
                        return observableThrowError(res);
                    }
                }));
        } else if (!this.isWhitelisted(req)) {
            authService.logout();
            return next.handle(req);
        } else {
            return next.handle(req);
        }
    }

    isWhitelisted(req: HttpRequest<any>) {
        return !!this.whitelistUrls.find((url) => {
            return url.indexOf(req.url) !== 1;
        });
    }
}
